/**
 * Unified "solid pill" badge style — the one used for role badges on the
 * Gestión de equipo page (Perito / Responsable / Trabajador). Apply this to all
 * semantic status / type / category badges across the app so they share the same
 * size, font, weight, roundness and solid-colour look. Only the colour changes
 * per badge meaning (see PILL_COLORS).
 *
 * Usage:
 *   <span className={PILL_BASE} style={{ backgroundColor: PILL_COLORS.blue }}>Químico</span>
 */
export const PILL_BASE =
  "inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded-lg text-white border-transparent whitespace-nowrap";

/** Semantic colours for the solid pills (white text on these). */
export const PILL_COLORS = {
  red: "#E5574E", // alerta, crítico, retrasada, cancelada, error, stock agotado
  green: "#16A971", // en stock, completada, biológico, inspección, activo, ok
  blue: "#2B7DE0", // químico, monitoreo, en progreso, info, responsable
  amber: "#E0962E", // pendiente, stock bajo, mantenimiento, advertencia
  indigo: "#6366F1", // tratamiento (tipo de tarea)
  teal: "#0FA9B8", // visita
  slate: "#64748B", // sin clasificar, otro, neutro
  violet: "#8B5CF6", // perito
} as const;

export type PillColor = keyof typeof PILL_COLORS;

/** Solid-pill colour per task status — shared so every surface (planner popup,
 * campaign/cycle breakdown, etc.) renders task statuses identically. */
export const TASK_STATUS_PILL_COLOR: Record<string, PillColor> = {
  pending: "amber",
  in_progress: "blue",
  completed: "green",
  cancelled: "red",
};

/** Convenience: inline style for a solid pill background. */
export function pillStyle(color: PillColor): { backgroundColor: string } {
  return { backgroundColor: PILL_COLORS[color] };
}
